export default {
  text: {
    en: `
      Scentbird offers a limited run of super-luxe, full-size products, with amazing savings.
      Premium Products cost an additional $5 or $10, which you’ll see reflected on your
      account - for both new & existing members. 
    `,
  },
}
